import {Component} from 'react';
import "./GameViews/gamePhase2.css"

class SpinnerLegendCard extends Component {
  constructor(props) {
    super(props);
    this.state={
   
    }    
}

render() {
      if (this.props.legendInfo.textName === "||jobName||"){
            this.textName = this.props.jobName;
      }else{
            this.textName = this.props.legendInfo.textName;
      }
     
return <>
    
            <tr className="text-left">
              <th className="legend-small-box py-0 gameView-text-size text-center"
              style={{backgroundColor: this.props.legendInfo.colorCode}}>{this.props.legendInfo.number}</th>
              <th></th>
              <th className="gameView-text-size py-0 px-2">{this.textName}</th>
            </tr>
     
   </>
  }
}

export default SpinnerLegendCard;